// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 297) return "static/chunks/297-9969040db132fbeb.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"233":"c5dd9fd575fe5251","554":"f160c59542153f74","740":"dbc52b59ab981e58","925":"5690fd632cae735d","951":"c5240720d46af63f"}[chunkId] + ".js";
};